export const StyledHeader = (props:{heading: string})=>{

    return(
        <div className='flex-row center-align'  >
            <div style={{width: 10, height: 40, backgroundColor: 'purple'}} />
            <h1>{props.heading}</h1>
        </div>
    )

}